module.exports = __webpack_public_path__ + "img/inbestme.9238764e.png";